import React from 'react';
import { TableLegend as TableLegendComponent } from '../../../../components';
import i18n from '../../../../i18n';
import { getUrlQueryParams, getSelectedLocationName } from '../../../../actions';
import { useAppContext } from '../../../../context/AppState.jsx';

export default function TableLegend() {
	const [state] = useAppContext();
	const urlParams = getUrlQueryParams();

	const conf = urlParams.significantChange ? urlParams.significantChange : '90';

	const legend = [
		{
			class: 'positiveChange',
			label: i18n.t('Improvement is significant at {{conf}}% confidence level', { conf }),
		},
		{
			class: 'negativeChange',
			label: i18n.t('Deterioration is significant at {{conf}}% confidence level', { conf }),
		},
	];

	if (urlParams.groupHighlight) {
		const highlightLabel =
			getSelectedLocationName(state, urlParams.groupHighlight) || i18n.t('Highlighted group/location');
		legend.push({
			class: 'groupHighlight',
			label: highlightLabel,
		});
	}

	return <TableLegendComponent legend={legend} />;
}
